import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { useEffect, useState } from "react";
import { OrderTransport } from "src/app/transports/order";
import { TOffSiteOrderType } from "src/app/types/orders/order";

const useGetAllUrlsFromMoneySite = (moneySiteId?: number, initialRequest?: false) => {
    const [urlsByMoneySiteOptions, setUrlsByMoneySiteOptions] = useState<
        Array<SimpleFormSelectOption & { siteOrderType: TOffSiteOrderType }>
    >([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetch = (fMoneySiteId?: number) => {
        if (!fMoneySiteId) return;
        setLoading(true);

        OrderTransport.findAllUrlsByMoneySiteOptions(fMoneySiteId)
            .then((res) => setUrlsByMoneySiteOptions(res))
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = (rMoneySiteId?: number) => {
        fetch(rMoneySiteId);
    };

    useEffect(() => {
        if (initialRequest) fetch(moneySiteId);
    }, []);

    return { urlsByMoneySiteOptions, fetch, refresh, loading, error };
};

export default useGetAllUrlsFromMoneySite;
